import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/apps/disputes/layouts/default.vue").then(m => m.default || m)),
  "claim-lab": defineAsyncComponent(() => import("/opt/buildhome/repo/apps/claim-lab/layouts/claim-lab.vue").then(m => m.default || m)),
  "auth-public": defineAsyncComponent(() => import("#build/layouts.public.HhBEhdkxED8_lCnB80fjY5qoLTVDJ9EaioYBIaAlqxk.vue").then(m => m.default || m))
}